import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getComponent(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}component/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addComponent(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}component/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddComponentType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/component/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddOs() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/os/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddHub() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/hub/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddAsset() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/asset/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByComponent(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}component/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateComponent(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}component/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}